<ng-container *transloco="let t; prefix: 'loggedout'">
    <div class="container py-5">
        <div class="d-flex justify-content-center">
            <div class="content-box w-100" style="max-width: 480px;">
                <h3 class="card-title">{{ t("title") }}</h3>
                <p class="card-text">
                    {{ t("text") }}
                </p>
                <button class="btn wp-btn float-end" type="button" (click)="onHomeClick()">{{ t("buttonlabel")
                    }}</button>
            </div>
        </div>
    </div>
</ng-container>